/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PointGeometry
 */
export interface PointGeometry {
    /**
     * 
     * @type {string}
     * @memberof PointGeometry
     */
    type: PointGeometryTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof PointGeometry
     */
    coordinates: Array<number>;
}


/**
 * @export
 */
export const PointGeometryTypeEnum = {
    Point: 'Point'
} as const;
export type PointGeometryTypeEnum = typeof PointGeometryTypeEnum[keyof typeof PointGeometryTypeEnum];


/**
 * Check if a given object implements the PointGeometry interface.
 */
export function instanceOfPointGeometry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "coordinates" in value;

    return isInstance;
}

export function PointGeometryFromJSON(json: any): PointGeometry {
    return PointGeometryFromJSONTyped(json, false);
}

export function PointGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PointGeometry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function PointGeometryToJSON(value?: PointGeometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'coordinates': value.coordinates,
    };
}

